const initialState = {
	variant_options: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "UPDATE_SELECTED_VARIANT_OPTIONS":
			// Determine if variant item is already in collection (Size, Colour, etc)
			let foundIndex = state.variant_options.some((item, index) => {
				return action.variant_id === item.variant_id;
			});

			// console.log("UPDATE_SELECTED_VARIANT_OPTIONS", action, foundIndex);

			// Add to selected items
			if (!foundIndex) {
				return {
					...state,
					variant_options: [].concat(state.variant_options, {
						variant_id: action.variant_id,
						option_id: action.option_id
					})
				};

				// Change selected item
			} else {
				// Loop over each variant option
				const variant_options = state.variant_options.map((variant, i) => {
					// If this variant item id is not the one being changed, do nothing
					if (variant.variant_id !== action.variant_id) {
						return variant;
					}

					// console.log('Updated Item:', action.variant_id, action.option_id)
					return Object.assign({}, variant, { option_id: action.option_id });
				});

				return { ...state, variant_options };
			}

		case "UPDATE_SELECTED_VARIANT":
			return { ...state, variant: action.variant };

		case "VARIANT_UNLOAD":
			return initialState;

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/productVariant.js